(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
if (!window.__lonoDrawerAgreementFeedback) {
  window.__lonoDrawerAgreementFeedback = true;
  document.addEventListener('submit', (event) => {
    if (!(event.target instanceof HTMLFormElement)) return;
    const form = event.target;
    if (!form.closest('#cart-drawer') || !form.querySelector('[name="checkout"]')) return;
    const toggle = form.querySelector('#termsCheckbox');
    if (!toggle || toggle.checked) return;
    event.preventDefault();
    toggle.setAttribute('aria-invalid', 'true');
    const label = form.querySelector('#termsLabel');
    if (label) {
      label.classList.remove('lono-agreement-error');
      void label.offsetWidth;
      label.classList.add('lono-agreement-error');
    }
    toggle.focus({preventScroll:true});
  }, true);
  document.addEventListener('change', (event) => {
    if (!event.target.matches('#cart-drawer #termsCheckbox') || !event.target.checked) return;
    event.target.removeAttribute('aria-invalid');
    event.target.closest('label')?.classList.remove('lono-agreement-error', 'highlight-error');
  });
}

  } catch(e) { console.error(e); }
})();
})();
